import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Navbar } from '../../landing/Navbar';
import { useLayout } from '../../../context/LayoutContext';
import { useTheme } from '../../../context/ThemeContext';

export const JournalLayout: React.FC = () => {
  const { sidebarCollapsed, zoomLevel } = useLayout();
  const { isDarkMode } = useTheme(); // Get theme state
  
  // Mobile detection state
  const [isMobile, setIsMobile] = useState(false);

  // Check if we're on mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768); // md breakpoint
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  // Calculate sidebar width
  const sidebarWidth = sidebarCollapsed ? 64 : 256; // 16 * 4 = 64px, 64 * 4 = 256px

  return (
    <div className={`flex flex-col h-screen app-container ${isDarkMode ? 'dark' : ''}`}>
      {/* Global Navbar */}
      <Navbar />

      <div className="flex flex-1 bg-gray-50 dark:bg-gray-900 overflow-hidden relative z-0">
        {/* Atmospheric lighting effects - exact same as HeroSection */}
        <div className="absolute top-0 right-0 w-[800px] h-[800px] rounded-full bg-primary-500/10 blur-[120px] -z-10"></div>
        <div className="absolute bottom-0 left-0 w-[800px] h-[800px] rounded-full bg-gray-300/20 dark:bg-gray-600/20 blur-[120px] -z-10 translate-y-1/3"></div>
        
        {/* Noise overlay */}
        <div className="noise-bg"></div>

        {/* Sidebar */}
        <Sidebar />

        {/* Main Content - RESPONSIVE TO SIDEBAR WIDTH AND ZOOM */}
        <main 
          className="relative flex-1 overflow-auto p-8 md:p-8 pt-20 md:pt-8 z-10 transition-all duration-300"
          style={{ 
            marginLeft: isMobile ? '0px' : `${sidebarWidth}px`, // ✅ No margin on mobile
            transform: `scale(${zoomLevel / 100})`, // Apply zoom transform
            transformOrigin: 'top left', // Scale from top-left corner
            width: `${(100 / (zoomLevel / 100))}%`, // Compensate width for zoom
            minHeight: `${(100 / (zoomLevel / 100))}%` // Compensate height for zoom
          }}
        >
          <div className="container mx-auto max-w-6xl">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};